<template>
  <span v-html="formatContent"></span>
</template>
<script>
import { escapeHTML } from '@/utils/common'
import {i18n} from '@/utils/i18n'

export default {
  name: 'MentionsContent',
  props: {
    content: String,
    metionAllString: String,
    itemTypedId: String
  },
  computed: {
    formatContent () {
      const self = this
      const re = /@\[(g-)?(\d+):([^\]]+)\]/g

      let mentions = []
      let children = []

      escapeHTML(this.content).replace(re, function (match, p0, p1, p2) {
        if (p1 === '0') {
          if (typeof self.metionAllString === 'string') {
            p2 = self.metionAllString
          } else {
            p2 = i18n.t('file.comment.metionAll')
          }
        }

        mentions.push({p0, p1: Number(p1), p2})

        return '|'
      }).split('|').forEach((val, idx) => {
        let mentionParams = mentions[idx]
        let mention = null

        if (mentionParams) {
          let { p2 } = mentionParams
          mention = `<a href="javascript:;">@${p2}</a>`
        }

        if (val === '') {
          if (!mentionParams) { return }
          children.push(mention)
        } else {
          let text = `<span>${val}</span>`
          children.push(text, mention)
        }
      })

      return children.join('')
    }
  },
  methods: {

  }
}
</script>
<style lang="postcss">

</style>
